export const translations = {
  en: {
    app_menu: {
      noAppAvailable: 'No applications available!',
      findAnApplicationPlaceholder: 'Find app',
      menuGroupButtonText: 'Group',
      myApplicationText: 'My Applications',
      allApplicationText: 'All Applications (alphabetically)',
    },
    app: {
      cardSubtitleNameTransl: 'User Custom Link',
      appRemoveDashboardText: 'Application removed from dashboard successfully',
      wentWrongAndRefreshText: 'Something went wrong. Please refresh and retry',
      errorOccurredText: 'An error occurred',
      customLinkCreatedText: 'Custom link created',
      customLinkUpdatedText: 'Custom link updated',
      somethingWentWrongText: 'Something went wrong',
      noAppsFoundText: 'No Apps found!',
      newAppSavedText: 'New setting is saved!',
      errorOccurredSaveAppText: 'An error occurred saving the order of apps!',
      resetSuccessfully: 'Reset successful!',
      resetUnSuccessfully: 'Reset not successful!',
      errorOccurredResetText: 'An error occurred while resetting.',
      failedFindAppText: 'Failed to find the edit application',
      invalidInputsText:
        'Invalid inputs! Please verify whether all the values are correct',
    },
    home_icon_toggle: {
      oldIconsLabel: 'Old Version',
    },
    hello_world: 'Hello world!',
    another_text: 'Another text',
    chipcardBalance: 'Your card balance',
  },
  it: {
    app_menu: {
      noAppAvailable: 'Non ci sono applicazioni disponibili!',
      findAnApplicationPlaceholder: 'Cerca app',
      menuGroupButtonText: 'Gruppo',
      myApplicationText: 'Le mie applicazioni',
      allApplicationText: 'Tutte le applicazioni (ordine alfabetico)',
    },
    app: {
      cardSubtitleNameTransl: 'Link personalizzato',
      appRemoveDashboardText: 'Applicazione rimossa dal dashboard con successo',
      wentWrongAndRefreshText:
        'Si è verificato un errore. Aggiornare e riprovare',
      errorOccurredText: 'Si è verificato un errore',
      customLinkCreatedText: 'Link personalizzato creato',
      customLinkUpdatedText: 'Link personalizzato aggiornato',
      somethingWentWrongText: 'Si è verificato un errore',
      noAppsFoundText: 'Nessuna applicazione trovata!',
      newAppSavedText: 'La nuova impostazione è salvata!',
      errorOccurredSaveAppText:
        'Si è verificato un errore nel salvataggio del ordine delle applicazioni!',
      resetSuccessfully: 'Ripristino riuscito!',
      resetUnSuccessfully: 'Ripristino fallito!',
      errorOccurredResetText:
        'Si è verificato un errore durante il ripristino.',
      failedFindAppText: 'Impossibile trovare applicazione di modifica.',
      invalidInputsText:
        'Dati inseriti non validi! Verificare se tutti i valori sono corretti',
    },
    home_icon_toggle: {
      oldIconsLabel: 'Versione Classica',
    },
    hello_world: 'Ciao mondo!',
    another_text: 'Un altro testo',
    chipcardBalance: 'Saldo della tua carta',
  },
  de: {
    app_menu: {
      noAppAvailable: 'Keine Apps verfügbar!',
      findAnApplicationPlaceholder: 'App finden',
      menuGroupButtonText: 'Gruppe',
      myApplicationText: 'Meine Anwendungen',
      allApplicationText: 'Alle Anwendungen (alphabetisch)',
    },
    app: {
      cardSubtitleNameTransl: 'Benutzerdefinierter Link',
      appRemoveDashboardText: 'Anwendung erfolgreich vom Dashboard entfernt',
      wentWrongAndRefreshText:
        'Es ist ein Fehler aufgetreten. Bitte aktualisieren und erneut versuchen',
      errorOccurredText: 'Es ist ein Fehler aufgetreten',
      customLinkCreatedText: 'Benutzerdefinierter Link erstellt',
      customLinkUpdatedText: 'Benutzerdefinierter Link aktualisiert',
      somethingWentWrongText: 'Es ist ein Fehler aufgetreten',
      noAppsFoundText: 'Keine Apps gefunden!',
      newAppSavedText: 'Neue Einstellung wird gespeichert!',
      errorOccurredSaveAppText:
        'Beim Speichern der Reihenfolge der Anwendungen ist ein Fehler aufgetreten!',
      resetSuccessfully: 'Erfolgreich zurückgesetzt!',
      resetUnSuccessfully: 'Zurücksetzen misslungen!',
      errorOccurredResetText: 'Beim Zurücksetzen ist ein Fehler aufgetreten.',
      failedFindAppText:
        'Die Anwendung zum Bearbeiten konnte nicht gefunden werden',
      invalidInputsText:
        'Ungültige Eingaben! Bitte überprüfen Sie, ob alle Werte korrekt sind.',
    },
    home_icon_toggle: {
      oldIconsLabel: 'Alte Version',
    },
    hello_world: 'Hallo Welt!',
    another_text: 'Ein anderer Text',
    chipcardBalance: 'Guthaben deiner Karte',
  },
};
